export const Logo = ({ dark = false, size = 34 }) => (
  <span className="inline-flex items-center gap-2.5">
    <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true" focusable="false">
      <rect width="64" height="64" rx="14" fill="#0066FF" />
      <rect x="15" y="16" width="30" height="7" rx="1.5" fill="#FFFFFF" />
      <rect x="15" y="28.5" width="20" height="7" rx="1.5" fill="#FFFFFF" />
      <rect x="15" y="41" width="30" height="7" rx="1.5" fill="#FFFFFF" />
      <path d="M43 24.5 L54 32 L43 39.5 Z" fill="#FFFFFF" />
    </svg>
    <span className="leading-none">
      <span
        className={`block font-display font-extrabold tracking-tight text-[16px] ${
          dark ? "text-white" : "text-ink"
        }`}
      >
        ELI CAPITAL
      </span>
      <span
        className={`block font-mono text-[9px] tracking-[0.34em] mt-[5px] ${
          dark ? "text-white/60" : "text-slate-500"
        }`}
      >
        INVESTMENTS
      </span>
    </span>
  </span>
);

export default Logo;
